// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/ed2394681e0772178705.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"1dacf62c2cb190b07261","136":"c8b8f07cd8679340f299","137":"4787c5ecfe9d7f7ffb4a"}[chunkId] + ".chunk.js";
};